import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';
import type {IEvent} from '../types/IEvent';


export const selectBrandSettings = (state: IRootMachineSnapshot) => {
  return (
    (state.context.eventDetails as IEvent)?.brand_settings ||
    state.context.eventTemplate?.brand_settings
  );
};
